/**
 * Typed API client for User Agreements (Policies) — Epic 226.
 *
 * Versioned policy documents (ToS, acceptable-use, etc.) that users accept.
 * Distinct from the Legal & Agreements module (MOU/NDA/SOW). Mirrors the
 * user-agreements surface of internal/surveys.
 */

import { apiClient } from '@/lib/apiClient';

export interface UserAgreement {
  id: string;
  code: string;
  version: string;
  title: string;
  requiredForLogin: boolean;
  createdAt: string;
}

export async function listAgreements(): Promise<UserAgreement[]> {
  const { data } = await apiClient.get<UserAgreement[]>('/user-agreements');
  return data;
}

export interface PublishAgreementRequest {
  code: string;
  version: string;
  title: string;
  body: string;
  requiredForLogin?: boolean;
}

export async function publishAgreement(req: PublishAgreementRequest): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>('/user-agreements', req);
  return data;
}

export async function acceptAgreement(id: string): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>(`/user-agreements/${id}/accept`, {});
  return data;
}
